import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-process-pill',
  templateUrl: './process-pill.component.html',
  styleUrls: ['./process-pill.component.scss'],
})
export class ProcessPillComponent {
  @Input() public text: string;
  @Input() public completionPercentage?: number;
}
